var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"valueStrength"}},[_c('div',{staticClass:"value-item",attrs:{"id":"radar"}}),_c('div',{staticClass:"value-item pl-5 p-2 c-white f20"},[_c('dv-capsule-chart',{staticClass:"wi100 hi100",attrs:{"config":_vm.chartConfig}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }